import { render, staticRenderFns } from "./IncalculationCard.vue?vue&type=template&id=3b13535a&scoped=true"
import script from "./IncalculationCard.vue?vue&type=script&lang=js"
export * from "./IncalculationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b13535a",
  null
  
)

export default component.exports